import { render } from "./PasswordComplete.vue?vue&type=template&id=7486115e"
import script from "./PasswordComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordComplete.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/password/PasswordComplete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7486115e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7486115e', __exports__)) {
    api.reload('7486115e', __exports__)
  }
  
  module.hot.accept("./PasswordComplete.vue?vue&type=template&id=7486115e", () => {
    api.rerender('7486115e', render)
  })

}


export default __exports__